export default "__VITE_ASSET__VXLhunJH__"